import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const videoTestimonials = [{
  name: 'Olivia Alexandra',
  poster: 'https://cdn.magicpatterns.com/uploads/ojwtkCDBWnwFrWHcHsaFMT/Screenshot_2026-05-15_at_07.19.20.png',
  src: 'https://assets.cdn.filesafe.space/Nj4YTDNh6AbGQwNQpn2w/media/6a069e83ff331dd8790f69da.mov'
}, {
  name: 'Arturo Munoz',
  poster: 'https://cdn.magicpatterns.com/uploads/dNTVcpqkoFwcGzMJSk8HyX/Screenshot_2026-05-15_at_07.18.51.png',
  src: 'https://assets.cdn.filesafe.space/Nj4YTDNh6AbGQwNQpn2w/media/6a069e83937389dca0328f40.mov'
}];
const writtenTestimonials = [{
  quote: 'Am participat la cursurile de Theta Healing® susținute de Adrian Huniade cu deschidere totală, iar experiența a depășit orice așteptare. Trainerul a fost extrem de empatic și bine pregătit, iar atmosfera caldă m-a făcut să mă simt în siguranță. Ceea ce mi-a plăcut cel mai mult a fost caracterul practic — am aplicat tehnicile în timp real și am observat rezultate rapide: claritate mentală, liniște interioară și încredere în mine. Recomand cu toată inima oricui își dorește o transformare autentică și profundă.',
  name: 'Carmen Crișan',
  title: 'Cursantă',
  initial: 'C'
}, {
  quote: 'Înainte de aceste cursuri eram pierdută, fără direcție, fără claritate. Cursurile de Theta Healing® cu maestrul Adrian Huniade au fost exact acel punct de cotitură. Cu blândețe și răbdare, a creat un spațiu în care m-am simțit în siguranță să mă deschid și să lucrez profund cu mine. Pas cu pas m-am stabilizat emoțional, am înțeles tiparele și am învățat să le schimb. Transformările s-au reflectat rapid în realitate: o casă, o afacere și conexiuni autentice cu cei dragi.',
  name: 'Feli Iscru',
  title: 'Cursantă',
  initial: 'F'
}, {
  quote: 'L-am descoperit pe Adrian acum aproximativ 6 ani, într-o perioadă în care eram derutat și nu aveam un drum clar în viață. În urma cursurilor lui, am început treptat să văd mai limpede pașii pe care trebuie să îi urmez. Mi-a reaprins scânteia interioară și m-a ajutat să capăt claritate și direcție.',
  name: 'Coras Nicolae Dumitru',
  title: 'Săud, jud. Bihor',
  initial: 'C'
}, {
  quote: 'Am participat la cursurile lui Adrian cu dorința de a lucra mai profund cu mine însămi. Experiența a fost peste așteptările mele — am învățat tehnici practice de identificare și schimbare a convingerilor limitative. Instructorul a fost calm, empatic și foarte clar, iar schimbările s-au observat chiar în timpul cursului.',
  name: 'Emilia Popșor',
  title: 'Medic pediatru, Calgary, Canada',
  initial: 'E'
}];
export function TestimonialsSection() {
  return <section className="py-20 lg:py-32 bg-gradient-to-br from-[#6B3FA0] via-[#5C3490] to-[#3D1F5C] relative overflow-hidden" data-id="element-1948">
      <div className="absolute top-0 left-0 w-[55%] h-[55%] bg-gradient-to-br from-white/[0.04] to-transparent rounded-br-full pointer-events-none" data-id="element-1949" />
      <div className="absolute bottom-0 right-0 w-[35%] h-[35%] bg-gradient-to-tl from-brand-gold/[0.04] to-transparent rounded-tl-full pointer-events-none" data-id="element-1950" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1951">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 lg:mb-24" data-id="element-1952">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-1953">
            Ce spun oamenii care au participat la cursuri
          </h2>
          <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full" data-id="element-1954" />
        </motion.div>

        {/* Video Testimonials — 2 side by side, embedded */}
        <div className="grid md:grid-cols-2 gap-8 mb-12 lg:mb-16" data-id="element-1955">
          {videoTestimonials.map((video, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white/[0.12] backdrop-blur-md rounded-3xl border border-white/15 overflow-hidden" data-id="element-1956">
              <div className="relative aspect-video bg-black" data-id="element-1957">
                <video className="w-full h-full object-cover" src={video.src} poster={video.poster} controls controlsList="nodownload nofullscreen noremoteplayback" disablePictureInPicture playsInline preload="metadata" data-id="element-1958" />
              </div>
              <div className="p-6 text-center" data-id="element-1959">
                <h4 className="font-heading font-bold text-white text-xl" data-id="element-1960">
                  {video.name}
                </h4>
              </div>
            </motion.div>)}
        </div>

        {/* Written Testimonials — 2 per row */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-1961">
          {writtenTestimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white/[0.12] backdrop-blur-md rounded-3xl p-8 lg:p-10 border border-white/15 relative flex flex-col h-full" data-id="element-1962">
              <Quote className="absolute top-8 left-8 w-12 h-12 text-brand-gold/30 rotate-180" data-id="element-1963" />

              <div className="relative z-10 pt-8 flex-grow flex flex-col" data-id="element-1964">
                <p className="font-subtitle italic text-lg text-white leading-relaxed mb-8 flex-grow" data-id="element-1965">
                  "{testimonial.quote}"
                </p>

                <div className="flex items-center gap-4 mt-auto" data-id="element-1966">
                  <div className="w-12 h-12 rounded-full bg-brand-gold/20 flex items-center justify-center text-brand-gold font-heading font-bold text-xl shrink-0" data-id="element-1967">
                    {testimonial.initial}
                  </div>
                  <div data-id="element-1968">
                    <h4 className="font-heading font-bold text-white" data-id="element-1969">
                      {testimonial.name}
                    </h4>
                    <p className="text-lg text-brand-gold" data-id="element-1970">
                      {testimonial.title}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mt-16 lg:mt-20 text-center" data-id="element-1971">
          <a href="https://academiadeabundenta.ro/testimoniale" target="_top" className="inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-cream font-heading font-semibold text-lg px-9 py-5 rounded-xl hover:bg-white hover:text-brand-text transition-colors duration-300 shadow-warm hover:shadow-warm-hover" data-id="element-1972">
            Vezi Toate Mărturiile
            <span aria-hidden="true" data-id="element-1973">→</span>
          </a>
        </motion.div>
      </div>
    </section>;
}